module.exports = __webpack_public_path__ + "d220afb2fde8cced3b09998e7bda8afe.svg";